import {
  PencilSimple,
  Circle,
  ArrowRight,
  Eraser,
  ArrowCounterClockwise,
} from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import {
  useAnnotationCanvas,
  type AnnotationTool,
} from '@/context/annotation-canvas.context';
import { cn } from '@/lib/utils';
import { useGT } from 'gt-react';

export function AnnotationToolbar() {
  const { isActive, activeTool, setActiveTool, clear, undo } =
    useAnnotationCanvas();
  const gt = useGT();

  const tools: {
    tool: AnnotationTool;
    icon: typeof PencilSimple;
    label: string;
  }[] = [
    {
      tool: 'freehand',
      icon: PencilSimple,
      label: gt('Freehand', { context: 'annotation drawing tool' }),
    },
    {
      tool: 'circle',
      icon: Circle,
      label: gt('Circle', { context: 'annotation drawing tool' }),
    },
    {
      tool: 'arrow',
      icon: ArrowRight,
      label: gt('Arrow', { context: 'annotation drawing tool' }),
    },
  ];

  if (!isActive) return null;

  return (
    <div className="flex items-center gap-1 px-2 py-1 border-b">
      {tools.map(({ tool, icon: Icon, label }) => (
        <Button
          key={tool}
          variant="ghost"
          size="sm"
          onClick={() => setActiveTool(tool)}
          className={cn(
            'h-7 w-7 p-0',
            activeTool === tool && 'bg-accent text-accent-foreground',
          )}
          title={label}
        >
          <Icon
            className="h-3.5 w-3.5"
            weight={activeTool === tool ? 'fill' : 'regular'}
          />
        </Button>
      ))}
      <div className="w-px h-4 bg-border mx-1" />
      <Button
        variant="ghost"
        size="sm"
        onClick={undo}
        className="h-7 w-7 p-0"
        title={gt('Undo', { context: 'button to undo last annotation' })}
      >
        <ArrowCounterClockwise className="h-3.5 w-3.5" />
      </Button>
      <Button
        variant="ghost"
        size="sm"
        onClick={clear}
        className="h-7 w-7 p-0"
        title={gt('Clear all', { context: 'button to clear all annotations' })}
      >
        <Eraser className="h-3.5 w-3.5" />
      </Button>
    </div>
  );
}
